import { CopyButton, Tooltip } from "@opendate-app/setlist";
import PropTypes from "prop-types";
import React from "react";

const money = (n) => (n >= 1000 ? `$${(n / 1000).toFixed(1)}k` : `$${Math.round(n)}`);
const dash = "—";

const dayFitTooltip = (h) =>
  h.dayFitSample > 0
    ? `Only ${h.dayFitSample} comparable ${h.dayFitSample === 1 ? "show" : "shows"} on ${h.day}s in the last 24 months — not enough to rate this day.`
    : `No comparable shows on ${h.day}s in the last 24 months yet.`;

const HoldDatesTable = ({ holds, header, footer, selectedId, onSelect, holdDatesText }) => (
  <div className="d2-card hd-table-card">
    <div className="hd-table-header">
      <div className="hd-table-header-main">
        <div className="hd-table-title-row">
          <h2 className="d2-card-title">Hold Dates</h2>
          {header && <span className="hd-count">{`${header.count} holds`}</span>}
        </div>
        {header && header.subtitle && <p className="hd-subtitle">{header.subtitle}</p>}
      </div>
      <div className="hd-table-header-actions">
        {header && header.bestAvailableLabel && (
          <span className="hd-best">{`Best available: ${header.bestAvailableLabel}`}</span>
        )}
        {holdDatesText && (
          <CopyButton
            value={holdDatesText}
            label="Copy hold dates"
            variant="secondary"
            size="sm"
          />
        )}
      </div>
    </div>
    <div className="hd-table-head">
      <div className="hd-col-hold">Hold</div>
      <div className="hd-col-date">Date</div>
      <div className="hd-col-fit">Day fit</div>
      <div className="hd-col-comp">Competing holds</div>
      <div className="hd-col-num">Proj. tickets</div>
      <div className="hd-col-num">Est. revenue</div>
    </div>
    {holds.map((h) => (
      <div
        key={h.id}
        role="button"
        tabIndex={0}
        aria-pressed={h.id === selectedId}
        data-hold-id={h.id}
        className={`hd-row${h.id === selectedId ? " hd-row-selected" : ""}`}
        onClick={() => onSelect(h.id)}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onSelect(h.id); } }}
      >
        <div className="hd-col-hold"><span className="hd-pos">{h.id}</span></div>
        <div className="hd-col-date">
          <div className="hd-day">{h.day}</div>
          <div className="hd-date-sub">{h.date}</div>
        </div>
        <div className="hd-col-fit">
          {h.dayFit ? (
            <span className={`hd-fit hd-fit-${h.dayFit.label.toLowerCase()}`}>
              {h.dayFit.label} · {h.dayFit.index.toFixed(1)}×
            </span>
          ) : (
            <Tooltip title={dayFitTooltip(h)}>
              <span className="hd-fit-none" tabIndex={0}>
                {h.dayFitSample > 0 ? `${h.dayFitSample} ${h.dayFitSample === 1 ? "show" : "shows"}` : "No history"}
              </span>
            </Tooltip>
          )}
        </div>
        <div className="hd-col-comp">
          {h.competing ? `1 — ${h.competing.name} (H${h.competing.position})` : "None"}
        </div>
        <div className="hd-col-num">{h.projTickets ? `${h.projTickets.low}–${h.projTickets.high}` : dash}</div>
        <div className="hd-col-num hd-strong">
          {h.estRevenue ? `${money(h.estRevenue.low)}–${money(h.estRevenue.high)}` : dash}
        </div>
      </div>
    ))}
    {footer && <div className="hd-table-footer">{footer}</div>}
  </div>
);

HoldDatesTable.propTypes = {
  holds: PropTypes.array.isRequired,
  header: PropTypes.shape({
    count: PropTypes.number,
    subtitle: PropTypes.string,
    bestAvailableLabel: PropTypes.string,
  }),
  footer: PropTypes.string,
  selectedId: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  holdDatesText: PropTypes.string,
};

export default HoldDatesTable;
